var _module_exports = "<div class=\"sf-analytics-function-description\">\n    Calculate the difference between the current value and the previous value.\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/analytics/block/DELTA/config.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;